import { Component } from "react";
import { Container, Row, Col, Image, Collapse, Form, FormControl } from 'react-bootstrap';
// import CheckIcon from '@material-ui/icons/Check';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Button } from '@material-ui/core';
import { Events, scrollSpy, scroller } from 'react-scroll';
import BeadMeerBanner from "./component/BeadMeerBanner";

import { colorPens } from './utils/colors';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // validated: false,
            maintenance: true,
            searchKeywords: null
        }

        this.handleSearch = this.handleSearch.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
    }

    componentDidMount() {
        console.log(window.location.href);
        // if (window.location.href.startsWith("http://localhost") ||
        //     window.location.href.startsWith("https://rush.beadmeer.com")) {
        //     this.setState({
        //         maintenance: false
        //     });
        // }
        this.setState({ maintenance: false });

        Events.scrollEvent.register('begin', function (to, element) {
            console.log('begin', arguments);
        });

        Events.scrollEvent.register('end', function (to, element) {
            console.log('end', arguments);
        });

        scrollSpy.update();
    }

    componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
    }

    handleSetActive(to) {
        console.log(`handleSetActive ${to}`);
    }

    handleInvite() {
        window.location.href = '/invite';
    }

    handleSearch(e) {
        // let form = e.currentTarget;

        e.preventDefault();
        e.stopPropagation();

        if (this.state.searchKeywords === null || this.state.searchKeywords.length < 3) {
            alert('Search keywords need to be more than 3-character long.');
        }
        //  else {
        //     this.setState({ validated: true });
        // }
        else {
            window.location.href = `/search/${this.state.searchKeywords}`;
        }
    }

    handleKeywordChange(e) {
        // window.location.href = '/search';
        this.setState({ searchKeywords: e.target.value });
    }

    render() {
        return (
            <Container fluid>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row className="justify-content-center">
                    <Col>
                        <BeadMeerBanner />
                        {/* <div align="center" style={{ fontSize: '3em' }}><b>BeadMeer</b></div>
                        <div align="center" style={{ fontSize: '1em' }}>One-stop Jewellery Pattern Search</div> */}
                    </Col>
                </Row>
                <br />

                {
                    this.state.maintenance ?
                        (<><Row className="justify-content-center">
                            <Col md={8}>
                                <Button variant="contained" disableElevation onClick={() => { alert('We are sorry about your inconvenience. Please try it again later!'); }}>Maintenance in Progress</Button>
                            </Col>
                        </Row></>)
                        :
                        (<><Row className="justify-content-center">
                            <Col md={7}>
                                <Form md={9} className="d-flex" onSubmit={this.handleSearch}>
                                    <FormControl
                                        type="search"
                                        placeholder="enter ingredient, technique, etc to find out!"
                                        name="searchKeywords"
                                        // className="mr-2"
                                        aria-label="Search"
                                        onChange={this.handleKeywordChange}
                                    />
                                    <Col md={1}>&nbsp;</Col>
                                    {/* <Button md={2} variant="outlined" onClick={() => { this.handleSearch(); }}>Search</Button> */}
                                    <Button md={2} variant="outlined" type="submit">Search</Button>
                                </Form>
                            </Col>
                        </Row>
                            <br />
                            <br />
                            <Row className="justify-content-center">
                                <Col md={8}>
                                    <Button variant="contained" disableElevation onClick={() => { window.location.href = `/search/m-a-r-u-k-o`; }}>I'm feeling lucky</Button>
                                </Col>
                            </Row>
                            <br />
                            <br /></>)
                }
            </Container>
        );
    }
}

export default Home;